import { Container, Graphics } from "pixi.js";
import { HORIZON, outdoor, tree } from "./common.js";

/**
 * El Parque ¡Ajá!: área verde con experimentos de física al aire libre.
 *
 * Los aparatos del fondo son escenario. El experimento con el que se juega es un
 * elemento del catálogo —`parque-experimento`— y lo dibuja el motor: si lo pintara
 * también aquí habría dos, y sólo uno respondería al clic.
 */
export function parque(): Container {
  const scene = outdoor({ ground: 0x5faa5f, sky: 0x9ec9e8, hedge: 0x3f8f4f });

  // Camino de tierra que entra desde la calle y se abre en el claro.
  const path = new Graphics();
  path.moveTo(380, HORIZON).lineTo(580, HORIZON).lineTo(760, 540).lineTo(200, 540);
  path.fill({ color: 0xc2a878, alpha: 0.75 });
  scene.addChild(path);

  scene.addChild(tree(90, HORIZON + 46, 1.1));
  scene.addChild(tree(870, HORIZON + 52, 1.2));
  scene.addChild(tree(250, HORIZON + 18, 0.7));

  // Péndulo gigante: el aparato que da nombre a lo que se juega aquí.
  const pendulum = new Graphics();
  pendulum.rect(690, 120, 12, 130).fill(0xb9c0c6);
  pendulum.rect(600, 112, 190, 12).fill(0xb9c0c6);
  pendulum.moveTo(696, 124).lineTo(640, 196).stroke({ width: 3, color: 0x51606e });
  pendulum.circle(640, 204, 16).fill(0xe8c33c).stroke({ width: 3, color: 0x8c7a2a });
  scene.addChild(pendulum);

  // Espejo cóncavo, el otro clásico de un parque de ciencia.
  const mirror = new Graphics();
  mirror.arc(180, 200, 54, Math.PI, 0).fill({ color: 0xc9d8e2, alpha: 0.95 });
  mirror.rect(174, 200, 12, 46).fill(0x8f979c);
  scene.addChild(mirror);

  return scene;
}
